<template>
  <div>
    <div class="NativePage">
      <TopBar pagetitle="电子卡片" back-url="/users/index" />
      <!-- <topTab select="0" back-url="/users/index" @change="DiveTypeSelect" /> -->
      <van-steps v-if="!loading" direction="vertical" :active="-1" class="cardlist">
        <!-- <van-step>
          <div @click="onCrossCertificationList">
            <div class="title">
              {{ formatDate(new Date(),"yyyy-MM-dd") }}<br>
              领取一张其他组织交叉认证卡片
            </div>
            <img src="/img/crossCertification.jpg">
          </div>
        </van-step> -->
        <van-step v-for="item in certifications" :key="item.certificationId">
          <div @click="selectCard(item.certificationId)">
            <div class="title">
              {{ formatDate(item.dateIssue,"yyyy-MM-dd") }}<br>
              {{ item.nameFull }}
            </div>
            <div class="body">
              发证地区：{{ item.divecenterCountry+" "+ item.divecenterCity }}<br>
              潜店名称：{{ item.divecenterName }}
            </div>
            <img :src="item.imageFront">
          </div>
        </van-step>
      </van-steps>
      <div v-if="!loading &&(!certifications || certifications.length<=0)" class="emptyNotice"><i class="iconfont iconclosex" /><br>暂无卡片</div>
      <NativeBar select="users" />
    </div>
  </div></template>
<script>
import request from '@/utils/request'
import { Step, Steps } from 'vant'
import NativeBar from '@/components/NativeBar'
import TopBar from '@/components/TopBar'
import { initPage, formatDate } from '@/utils/base'
export default {
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    NativeBar,
    TopBar
  },
  data() {
    return {
      certifications: [],
      loading: true
    }
  },
  created() {
    initPage(false)
    this.loading = true
    request({
      url: '/user/getUserCertificationList',
      method: 'post'
    }).then(response => {
      this.loading = false
      if (!response.success) {
        return
      }
      this.certifications = response.data
    })
  },
  methods: {
    formatDate,
    DiveTypeSelect(typeId) {
      console.log('typeId', typeId)
    },
    selectCard(cardId) {
      this.$router.replace('/textbook/licenseCard?cardId=' + cardId)
    },
    onCrossCertificationList() {
      this.$router.replace('/textbook/crossCertificationList?backurl=/textbook/license')
    }
  }
}
</script>

<style scoped>
.van-step__circle{
  background-color: #E32119;
  border: 1px solid #000;
}
.van-step__line{
  background-color: #000 !important;
  margin-left: 1px;
}
.cardlist .title
{
  color: #000 ;
  font-weight: 700;

}
.cardlist .body{
  color: #000;
  margin-top: 0.8em;
  font-size: 0.9em;
}
.cardlist img{
  width: 90%;
  margin-top: 0.8em;
  border-radius: 1em;
}

.emptyNotice{
  text-align: center;
  margin-top: 40%;
}
.emptyNotice i{
  font-size: 3em;
  line-height: 2.4em;
  color: #ccc;
}
</style>
